/**
 * Sentry Error Tracking
 * 
 * Tracks JavaScript errors, unhandled promise rejections, and other issues.
 * Requires Sentry DSN to be configured in theme settings.
 * Sentry SDK is loaded via CDN in theme.liquid.
 */

(function() {
  'use strict';

  // Public API for Sentry error tracking
  window.sentryErrorTracking = {
    /**
     * Initialize Sentry with configuration
     * @param {Object} config - Sentry configuration
     * @param {string} config.dsn - Sentry DSN
     * @param {string} config.environment - Environment name
     * @param {number} config.sampleRate - Sample rate (0-100)
     */
    init: function(config) {
      if (!config || !config.dsn || config.dsn === '') {
        return; // Sentry not configured
      }

      // Wait for Sentry SDK to load (loaded via CDN in theme.liquid)
      function initSentry() {
        if (typeof window.Sentry === 'undefined') {
          setTimeout(initSentry, 100);
          return;
        }

        window.Sentry.init({
          dsn: config.dsn,
          environment: config.environment || 'production',
          tracesSampleRate: config.sampleRate ? parseFloat(config.sampleRate) / 100 : 1.0,
          beforeSend(event, hint) {
            // Filter out errors in development
            if (window.location.hostname === 'localhost' || window.location.hostname.includes('127.0.0.1')) {
              console.log('[Sentry] Error would be tracked:', event);
              return null; // Don't send in development
            }
            return event;
          }
        });

        // Set user context if available
        if (window.Shopify && window.Shopify.customerId) {
          window.Sentry.setUser({ id: window.Shopify.customerId });
        }

        // Set additional context
        window.Sentry.setContext('page', {
          url: window.location.href,
          path: window.location.pathname,
          referrer: document.referrer
        });
      }

      // Start initialization
      initSentry();
    }
  };
})();
